export default [
  "./app.vue",
  "./pages/**/*.{vue,js,ts,jsx,tsx}",
  "./layouts/**/*.{vue,js,ts,jsx,tsx}",
  "./components/**/*.{vue,js,ts,jsx,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/components/**/*.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/components/global/**/*.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/components/**/*.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/layouts/**/*.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/pages/**/*.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/plugins/**/*.{js,ts,mjs}",
  "/builds/s-o-f/vkusilosos-frontend/composables/**/**/*.{js,ts,mjs}",
  "/builds/s-o-f/vkusilosos-frontend/composables/**/*.{js,ts,mjs}",
  "/builds/s-o-f/vkusilosos-frontend/utils/**/*.{js,ts,mjs}",
  "/builds/s-o-f/vkusilosos-frontend/{A,a}pp.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/{E,e}rror.{vue,js,jsx,mjs,ts,tsx}",
  "/builds/s-o-f/vkusilosos-frontend/app.config.{js,ts,mjs}"
]